var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.content,"disabled":_vm.isTooltipDisabled,"placement":"top-start"}},[_c('div',{staticClass:"wrapper",on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":function($event){_vm.isTooltipDisabled = true}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }